import { sharedLocalization } from 'controls/designer/features/widgets/localization';
import { translator } from 'core/localization';

export const i18n = translator(
	{
		'Pivot to Data Rows: Displays values from datasource rows instead of displaying them by columns.':
			{
				no: 'Roter til Data Rader: Viser verdier fra datakilderader i stedet for Ã¥ vise dem per kolonne.',
			},
		'Datasource chart': { no: 'Datakilde diagram' },
		Pie: { no: 'Pie' },
		'3D Pie': { no: '3D Pie' },
		Vertical: { no: 'Vertikal' },
		Horizontal: { no: 'Horisontal' },
		Chart: { no: 'Diagram' },
		'Chart type': { no: 'Diagramtype' },
		'Bar chart': { no: 'SÃ¸ylediagram' },
		'Pie chart': { no: 'Sektordiagram' },
		'Vertical stacked': { no: 'Vertikalt stablet' },
		'Horizontal stacked': { no: 'Horisontalt stablet' },
		Donut: { no: 'Smultring' },
		Display: { no: 'Visning' },
		'Data not found': { no: 'Data ikke funnet' },
		'Pivot data': { no: 'Pivoter data' },
		'Pivot data lets you turn the datasource table into a summary (pivot) grid.': {
			no: 'Pivoter data lar deg gjÃ¸re datakilde tabellen om til et sammendrag (pivot-tabell).',
		},
		Color: { no: 'Farge' },
		Column: { no: 'Kolonne' },
		'Column: Unique values in this field become headers and are used to aggregate values.': {
			no: 'Kolonne: Unike verdier i dette feltet blir kolonneoverskrifter og brukes til Ã¥ aggregere verdier.',
		},
		Value: { no: 'Verdi' },
		'Values: The numeric field(s) to summarize.': {
			no: 'De numeriske feltene som skal oppsummeres.',
		},
		'Color range': { no: 'Fargespekteret' },
		'Custom colors': { no: 'Tilpasset farger' },
		'Row label': { no: 'Rad navn' },
		'Row label (index): Selected column(s) define the categories that appear on your chart.': {
			no: 'Radetikett (indeks): Valgte kolonner definerer kategoriene som vises i diagrammet.',
		},
		'Hide Legend': { no: 'Skjul tegnforklaring' },
		Number: { no: 'Tall' },
		Text: { no: 'Tekst' },
		Invert: { no: 'Inverter' },
		'Row labels are required': {
			no: 'Radetikett er pÃ¥krevd',
		},
		'Show datasource grid on click': {
			no: 'Vis datasource kilde pÃ¥ klikk',
		},
		'Drilldown Datasource': {
			no: 'Drilldown Datakilde',
		},
		'Use Chart Datasource (set above)': {
			no: 'Bruk diagram datakilde (valgt over)',
		},
		'Split values': {
			no: 'Splitt verdier',
		},
		'Split values to separate chart columns': {
			no: 'Split verdier til egne diagram stolper',
		},
		'Export to CSV': {
			no: 'Eksporter til CSV',
		},
		'Decimal Numbers': {
			no: 'Desimaltall',
		},
		Time: {
			no: 'Tids',
		},
		'When disabled, the default time period from the datasource will be applied': {
			en: 'When disabled, the default time period from the datasource will be applied',
			no: 'NÃ¥r denne er deaktivert, brukes standard tidsperiode fra datakilden',
		},
	},
	sharedLocalization,
);
